@if (isLoading) {
    <usana-spinner [show]="true"></usana-spinner>
}

@if (product && !notFound && !isLoading) {
    <section class="section-pack">
        <div class="pack-breadcrumb">
            <!-- breadcrumb text intentionally left blank for now, to be added later -->
        </div>
        <div class="pack-container">
            @if (showLegacyPdp()) {
                <ng-container *ngTemplateOutlet="legacyPdp"></ng-container>
            } @else {
                <pdp-template [marketProductId]="product.marketProductId" (statusChanged)="onCmsStatus($event)">
                    <div slot="buyBoxTitle" class="pack-buy-box-container">
                        <ng-container *ngTemplateOutlet="buyBoxTitle"></ng-container>
                    </div>
                    @if (showPricing && hasPackPrice) {
                        <div slot="buyBox" class="price-wrapper">
                            <ng-container *ngTemplateOutlet="priceBlockContent"></ng-container>
                        </div>
                    }
                    <product-buy-box slot="buyBox" [productGroup]="productGroup" [product]="product" [mhpAddToAutoOrder]="selectedProductOption === 'addToAo'"></product-buy-box>
                </pdp-template>
            }
        </div>
    </section>
}

@if (notFound && !isLoading) {
    <section class="section-pack">
        <div class="container packDetails">
            <div class="row">
                <div class="col-sm-12 packMeta">
                    <div class="clearfix">
                        <h3 class="text-center" translate="cart.product.missing.title"></h3>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 packMeta text-center">
                    <span translate="cart.product.missing.text"></span>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 packMeta text-center margin-top-32">
                    <a href="javascript:void(0)" (click)="openLocaleSwitcher()">
                        <h4 class="margin-top-4"><span translate="cart.product.select.new.market"></span></h4>
                    </a>
                    <span translate="cart.product.or"></span>
                    <a [routerLink]="[CATALOG_ROUTE, -1]"><h4 class="margin-top-4"><span translate="cart.landing.view.all.products"></span>
                        <i class="fa-regular fa-circle-play" aria-hidden="true"></i></h4></a>
                </div>
            </div>
        </div>
    </section>
}

<ng-template #buyBoxTitle>
    @if (product.mhpPrebuiltPackId) {
        <div class="pack-number">
            <span translate="cart.mhp.pack.number"></span>{{product.mhpPrebuiltPackId}}
        </div>
    }
    <h1 class="heading-2 pack-name" automation-tag="productName"
        [innerHTML]="productGroup.productDescription?.name ?? product.productDescription?.name"></h1>
</ng-template>

<ng-template #priceBlockContent>
    <div class="radio-button-group">
        @if (showAddToAo) {
            <label class="radio-button">
                <input type="radio" name="packOption" value="addToAo" class="radio-visible" [(ngModel)]="selectedProductOption">
                <div class="pull-left margin-right-8">
                    <div class="price-row">
                        <span class="price-row-price" automation-tag="aoPrice">{{aoPriceDisplay}}</span>
                        @if (shouldDisplayVolume) {
                            <span class="price-row-vol" automation-tag="volume">
                                <span translate="cart.product.recommended.volume"></span>&nbsp;{{volume}}
                            </span>
                        }
                    </div>
                    @if (aoDiscountDisplay) {
                        <div class="price-row-desc" translate="cart.product.subscribe.save" [key]="'price'" [interpolate]="aoDiscountDisplay"></div>
                    } @else {
                        <div class="price-row-desc" translate="cart.product.subscribe"></div>
                    }
                </div>
            </label>
        }
        @if (showAddToCart) {
            <label class="radio-button">
                <input type="radio" name="packOption" value="addToCart" class="radio-visible" [(ngModel)]="selectedProductOption">
                <div class="pull-left margin-right-8">
                    <div class="price-row">
                        <span class="price-row-price" automation-tag="currentPrice">{{priceDisplay}}</span>
                        @if (shouldDisplayVolume) {
                            <span class="price-row-vol" automation-tag="volume">
                                <span translate="cart.product.recommended.volume"></span>&nbsp;{{volume}}
                            </span>
                        }
                    </div>
                    <div class="price-row-desc" translate="cart.product.one.time.order"></div>
                </div>
            </label>
        }
    </div>
</ng-template>

<ng-template #legacyPdp>
    <div class="flex-col">
        <div class="pack-images sticky-side">
            <div class="packMeta">
                <product-thumb-carousel [images]="product.productImages"
                                        [thumbSize]="'TH'"></product-thumb-carousel>
            </div>
        </div>
        <div class="pack-descriptions packMeta">
            <div class="pack-buy-box-container">
                <ng-container *ngTemplateOutlet="buyBoxTitle"></ng-container>

                @if (product?.productDescription?.shortDescription) {
                    <p class="short-description" [innerHTML]="product.productDescription.shortDescription"></p>
                }

                @if (showPricing && hasPackPrice) {
                    <div class="price-wrapper">
                        <ng-container *ngTemplateOutlet="priceBlockContent"></ng-container>
                    </div>
                }

                <product-buy-box [productGroup]="productGroup" [product]="product" [mhpAddToAutoOrder]="selectedProductOption === 'addToAo'"></product-buy-box>
            </div>

            @if (bodyBenefitTags?.length > 0) {
                <div class="page-section body-benefits">
                    <h2 class="heading-3" translate="cart.product.body.benefit"></h2>
                    <ul>
                        @for (tag of bodyBenefitTags; track tag.id) {
                            <li>
                                <img class="body-benefit"
                                     [src]="tag.imagePath" [alt]="tag.translationTag | translate" placement="bottom"
                                     attr.automation-tag="'bodyBenefit'-{{tag.id}}"/>
                                <span [translate]="tag.translationTag"></span>
                            </li>
                        }
                    </ul>
                </div>
            }

            @if (product?.productDescription?.longDescription) {
                <div class="page-section pack-description">
                    <h2 class="heading-3" translate="cart.product.moreinformation"></h2>
                    <div class="packDetails">
                        <p class="description" [innerHTML]="product.productDescription.longDescription | safeHtml"
                           automation-tag="longDescription"></p>
                    </div>
                </div>
            }

            @if (product?.supplementalInfo?.path) {
                <div class="page-section supplement-facts">
                    <h2 class="heading-3" translate="cart.product.supplementfacts"></h2>
                    <p translate="cart.product.supplementfacts.learn.more"></p>
                    <a [href]="product.supplementalInfo.path" target="_blank"
                       translate="cart.product.supplementfacts.download"></a>
                </div>
            }
        </div>
    </div>
</ng-template>
